module.exports = __webpack_public_path__ + "static/media/facebook.8c856a6a.svg";